"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapComponent = void 0;
var _ = require("lodash");
var React = require("react");
var Constants_1 = require("./Constants");
var MapComponent = /** @class */ (function (_super) {
    __extends(MapComponent, _super);
    function MapComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.googleMarkers = [];
        return _this;
    }
    MapComponent.prototype.clearLocations = function () {
        this.infoWindow = new google.maps.InfoWindow({});
        this.googleMarkers.forEach(function (marker) {
            google.maps.event.clearInstanceListeners(marker);
            marker.setMap(null);
        });
        this.googleMarkers = [];
    };
    MapComponent.prototype.fitBounds = function () {
        if (typeof google === 'undefined' || !this.gmap) {
            return;
        }
        var gmap = this.gmap;
        var bounds = new google.maps.LatLngBounds();
        var boundCoords = this.getBoundsCoords();
        if (!boundCoords.length) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: Constants_1.DEFAULT_COUNTRY }, function (res, status) {
                if (status === google.maps.GeocoderStatus.OK) {
                    gmap.setCenter(Constants_1.AMSTERDAM_COORDS);
                }
            });
            return;
        }
        _.forEach(boundCoords, function (boundCoord) {
            bounds.extend(new google.maps.LatLng(boundCoord.lat, boundCoord.lng));
        });
        // center the map to Amsterdam
        gmap.setCenter(Constants_1.AMSTERDAM_COORDS);
        // center the map to the geometric center of all markers
        gmap.setCenter(bounds.getCenter());
        gmap.fitBounds(bounds);
        // remove one zoom level to ensure no marker is on the edge.
        var currentZoom = gmap.getZoom();
        if (typeof currentZoom === 'number') {
            gmap.setZoom(currentZoom - 1);
            // set a minimum zoom 
            // if you got only 1 marker or all markers are on the same address map will be zoomed too much.
            var zoomAfterAdjustment = gmap.getZoom();
            if (typeof zoomAfterAdjustment === 'number' && zoomAfterAdjustment > 15) {
                gmap.setZoom(15);
            }
        }
    };
    MapComponent.prototype.onChange = function (map) {
        this.gMapProps = map;
        this.setState({ zoom: map.zoom, center: map.center });
    };
    MapComponent.prototype.buildCircleIcon = function (options) {
        if (options === void 0) { options = {}; }
        return {
            path: google.maps.SymbolPath.CIRCLE,
            scale: options.scale || 10,
            anchor: undefined,
            fillColor: options.fillColor || Constants_1.COLORS.green,
            fillOpacity: options.fillOpacity || 1,
            strokeColor: options.strokeColor || Constants_1.COLORS.white,
            strokeWeight: options.strokeWeight || 1,
            strokeOpacity: options.strokeOpacity || 1,
        };
    };
    MapComponent.prototype.drawPointMarker = function (pointMarker) {
        var MarkerWithLabel = require('markerwithlabel')(google.maps);
        var marker = new MarkerWithLabel(__assign({ map: this.gmap }, pointMarker.getOptions()));
        this.googleMarkers.push(marker);
    };
    MapComponent.prototype.drawWorkMarker = function (workMarker) {
        var _this = this;
        var marker = new google.maps.Marker(__assign({ map: this.gmap }, workMarker.getOptions()));
        marker.addListener('click', function () {
            _this.infoWindow.setContent(workMarker.getInfoWindowContent());
            _this.infoWindow.open(_this.gmap, marker);
        });
        this.googleMarkers.push(marker);
    };
    MapComponent.prototype.drawCluster = function (cluster) {
        var _this = this;
        var marker = new google.maps.Marker(__assign(__assign({ map: this.gmap }, cluster.getOptions()), { icon: this.buildCircleIcon({ fillColor: Constants_1.COLORS.blue }) }));
        marker.addListener('click', function () {
            _this.infoWindow.setContent(cluster.getInfoWindowContent());
            _this.infoWindow.open(_this.gmap, marker);
        });
        this.googleMarkers.push(marker);
    };
    return MapComponent;
}(React.Component));
exports.MapComponent = MapComponent;
